const RCB = "real-cookie-banner";
const RCL = "real-category-library";
const RML = "real-media-library";
const RPM = "real-physical-media";
export { RCB, RCL, RML, RPM };
